import { apiRequest } from './client';
import {
  Message,
  CreateMessageRequest,
  CreateMessageResponse,
} from './types';

// Get all messages for a specific chat
export const getMessagesByChatId = async (
  chatId: string,
  token: string
): Promise<Message[]> => {
  return apiRequest<Message[]>({
    endpoint: `/chats/${chatId}/messages`,
    method: 'GET',
    token,
  });
};

// Create a new message in a chat
export const createMessage = async (
  chatId: string,
  data: CreateMessageRequest,
  token: string
): Promise<CreateMessageResponse> => {
  return apiRequest<CreateMessageResponse>({
    endpoint: `/chats/${chatId}/messages`,
    method: 'POST',
    body: data,
    token,
    timeout: 60000, // 60 seconds for AI processing and file handling
  });
};
